<div class="svg-icon">
  <div
    class="svg-icon__wrapper"
    [ngClass]="[svgId ? 'img-' + svgId : '', iconClassName || '']"
  >
    <svg class="svg-icon__svg" xmlns="http://www.w3.org/2000/svg">
      <use
        data-qa="svg-icon-element"
        [attr.href]="'#icon-' + svgId"
        [attr.xlink:href]="'#icon-' + svgId"
      />
    </svg>
  </div>
</div>
